







import { Component, Vue } from 'vue-property-decorator';

@Component
export default class CompetenceCardMoreButton extends Vue {}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/parts/vacancies/card/components/btn/Button.vue